type PrimerCountdownProps = {
  entityName: string;
  countdown: number;
  hasStalePrimer?: boolean;
  onCancel: () => void;
};

export const COUNTDOWN_SECONDS = 8;

export default function PrimerCountdown({
  entityName,
  countdown,
  hasStalePrimer,
  onCancel,
}: PrimerCountdownProps) {
  return (
    <div className="w-full bg-white relative overflow-hidden font-sans px-0 md:px-9 pt-8 pb-7 border-0 border-b border-solid border-b-[rgba(0,0,0,0.133333)]">
      {/* progress bar */}
      <div
        className="absolute top-0 left-0 right-0 h-[3px] bg-smart-teal origin-left transition-transform duration-[900ms] linear"
        style={{
          transform: `scaleX(${
            (COUNTDOWN_SECONDS - countdown) / COUNTDOWN_SECONDS
          })`,
        }}
      />

      {/* label */}
      <div className="flex items-center gap-2 text-[11px] font-semibold tracking-[0.12em] text-[#1a7a79] uppercase">
        <span className="w-[6px] h-[6px] rounded-full bg-smart-teal shadow-[0_0_0_4px_rgba(36,169,167,0.18)]" />
        PRIMER · AUTO-GENERATE
      </div>

      {/* heading */}
      <div className="flex flex-col md:flex-row space-y-[20px] md:space-x-[20px] justify-between items-center">
        <div>
          <h2 className="text-[20px] leading-snug tracking-[-0.01em] text-[#1a202c] mt-[14px] mb-2 font-medium">
            {hasStalePrimer
              ? "Preparing to build a new primer for"
              : "Preparing to build your primer for"}{" "}
            <span className="text-[#4a5568]">{entityName}</span>
          </h2>
          {/* description */}
          <p className="m-0 text-sm leading-[1.55] text-gray-gray">
            We&apos;re preparing a primer with company background, recent
            filings, and consensus estimates so you have somewhere to start.
          </p>
          {/* actions */}
        </div>
        <div>
          <div className="flex justify-end gap-2">
            <button
              onClick={onCancel}
              className="px-4 py-[9px] text-[13px] font-medium bg-smart-teal text-white rounded-full border-none cursor-pointer"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
